
import React from "react";
import { Button } from "antd"
import { DownloadOutlined, FilePdfFilled } from '@ant-design/icons';
import "./index.css"

export default class extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            deviceType: "",
            questionnaireList: [],
            formList: [],
            isSuccess: false
        }
    }

    componentDidMount() {
    }

    render() {
        return <div className="userManual">
            <div className="content">
                <a target="_blank" rel="noopener noreferrer" href="https://www.svmeet.com:19000/public/resources/SkyTVUserManual.pdf">
                    <Button type="primary" icon={<FilePdfFilled />} size={20}>TV版小维会议使用手册</Button>
                </a>
                <a target="_blank" rel="noopener noreferrer" href="https://www.svmeet.com:19000/public/resources/PCUserManual.pdf">
                    <Button type="primary" icon={<FilePdfFilled />} size={20}>PC版使用手册</Button>
                </a>
                <a target="_blank" rel="noopener noreferrer" href="https://www.svmeet.com:19000/public/resources/MobileUserManual.pdf">
                    <Button type="primary" icon={<FilePdfFilled />} size={20}>手机版使用手册</Button>
                </a>
            </div>
        </div>
    }
}